import { getConstants } from "@utilifiles/methods/storage/storage"
import api from "@services/apiList"
import { emptyError } from "../../../../Types/ServicesType/servicesType"
import { RequestType } from "./types"
import instance from "@services/services"
const {receptionApi}=api
const { clinicId } = getConstants()
export const getEncounter=async(body:RequestType)=>{
    try {
        const result=await instance.post(receptionApi.getEncounter,body)
        return result.data
    } catch (error) {
        return emptyError
    }
}

export const getAllDoctor=async()=>{
    const result=await instance.get(receptionApi.getallDoctor)
    return result.data.response || []
}

export const getPatientByEncounter=async(id:number)=>{
    try {
        const result=await instance.get(`${receptionApi.getPatientByencounterId}/${clinicId}?id=${id}`)
        return result.data.response
    } catch (error) {
        return emptyError
    }
}

export const cancelEncounterService=async(body:{id:number,status:number, clinicId:number})=>{
    try {
        const result=await instance.post(receptionApi.cancelEncounter,body)
        return result.data
    } catch (error) {
        return emptyError
    }
}